import { cn } from '../lib/utils';
import { AlertTriangle, CheckCircle, Info, TrendingDown, TrendingUp } from 'lucide-react';

export const AlertBadge = ({ alerts, className }) => {
  const getAlertType = (alert) => {
    const lowerAlert = alert.toLowerCase();
    if (lowerAlert.includes('excellent') || lowerAlert.includes('strong') || lowerAlert.includes('solid')) {
      return 'success';
    }
    if (lowerAlert.includes('low') || lowerAlert.includes('missed') || lowerAlert.includes('masking')) {
      return 'warning';
    }
    if (lowerAlert.includes('review') || lowerAlert.includes('check') || lowerAlert.includes('focus')) {
      return 'info';
    }
    return 'info';
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case 'success': return <CheckCircle className="w-4 h-4 flex-shrink-0" />;
      case 'warning': return <AlertTriangle className="w-4 h-4 flex-shrink-0" />;
      default: return <Info className="w-4 h-4 flex-shrink-0" />;
    }
  };

  const getAlertStyles = (type) => {
    switch (type) {
      case 'success': return 'bg-emerald-50 border-emerald-200 text-emerald-800';
      case 'warning': return 'bg-amber-50 border-amber-200 text-amber-800';
      default: return 'bg-blue-50 border-blue-200 text-blue-800';
    }
  };

  if (!alerts || alerts.length === 0) {
    return null;
  }

  return (
    <div className={cn('space-y-2', className)}>
      {alerts.map((alert, index) => {
        const type = getAlertType(alert);
        return (
          <div 
            key={index}
            className={cn(
              'flex items-start gap-3 p-3 rounded-lg border',
              getAlertStyles(type)
            )}
            data-testid={`alert-${index}`}
          >
            {getAlertIcon(type)}
            <span className="text-sm leading-relaxed">{alert}</span>
          </div>
        );
      })}
    </div>
  );
};

export const AlertSummary = ({ alerts }) => {
  if (!alerts || alerts.length === 0) return null;

  const warningCount = alerts.filter(a => 
    a.toLowerCase().includes('low') || 
    a.toLowerCase().includes('missed') || 
    a.toLowerCase().includes('review')
  ).length;

  const successCount = alerts.filter(a => 
    a.toLowerCase().includes('excellent') || 
    a.toLowerCase().includes('strong')
  ).length;

  return (
    <div className="flex items-center gap-4 text-sm">
      {successCount > 0 && (
        <div className="flex items-center gap-1.5 text-emerald-600">
          <TrendingUp className="w-4 h-4" />
          <span>{successCount} positive</span>
        </div>
      )}
      {warningCount > 0 && (
        <div className="flex items-center gap-1.5 text-amber-600">
          <TrendingDown className="w-4 h-4" />
          <span>{warningCount} areas to review</span>
        </div>
      )}
    </div>
  );
};
